import { render } from "./Beritaisi.vue?vue&type=template&id=a3862d80"
import script from "./Beritaisi.vue?vue&type=script&lang=js"
export * from "./Beritaisi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__